import React from "react";

export default function Search({ fill, width, height, ...others }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...others}
      >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.50519 3.15899C6.3525 3.15899 5.24703 3.61689 4.43196 4.43196C3.61689 5.24703 3.15899 6.3525 3.15899 7.50519C3.15899 8.65787 3.61689 9.76335 4.43196 10.5784C5.24703 11.3935 6.3525 11.8514 7.50519 11.8514C8.65787 11.8514 9.76335 11.3935 10.5784 10.5784C11.3935 9.76335 11.8514 8.65787 11.8514 7.50519C11.8514 6.3525 11.3935 5.24703 10.5784 4.43196C9.76335 3.61689 8.65787 3.15899 7.50519 3.15899ZM3.61243 3.61243C4.64486 2.58001 6.04512 2 7.50519 2C8.96526 2 10.3655 2.58001 11.3979 3.61243C12.4304 4.64486 13.0104 6.04512 13.0104 7.50519C13.0104 8.76984 12.5752 9.98964 11.7879 10.9644L14 13.1805L13.1797 13.9993L10.9687 11.7843C9.99327 12.5739 8.77173 13.0104 7.50519 13.0104C6.04512 13.0104 4.64486 12.4304 3.61243 11.3979C2.58001 10.3655 2 8.96526 2 7.50519C2 6.04512 2.58001 4.64486 3.61243 3.61243Z'
        fill={fill}
      />
    </svg>
  );
}
